import React from "react";
import "./products.css";
import QuotePolicies from "../components/QuotePolicies";
import ProductHighlight from "../components/ProductHighlight";
import ProductsItem from "../components/ProductsItem";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";

import HarbourImg from "../media/img/2026prodimages/harbour.jpg";
import ShippingImg from "../media/img/2026prodimages/International-shipping-bg-hero.webp";
import HarbourHeaderImg from "../media/img/2026prodimages/harbour-header.jpg";

const slides = [
  { image: ShippingImg, label: "Logistics & Marine" },
  { image: HarbourHeaderImg, label: "Aviation & Travel" },
  { image: HarbourImg, label: "Cargo & Trade" },
];

/**
 * Product Page
 * This page is dedicated to enlisting and detailing all the Insurance products
 * @returns a JSX element containing components to make a complete page
 */

function Products() {
  return (
    <div className="Products_Page">

      {/* ── Hero slider with green overlay ── */}
      <div className="Products_Hero">
        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          speed={1200}
          loop
          className="Products_Hero_Swiper"
        >
          {slides.map((s, i) => (
            <SwiperSlide key={i}>
              <div
                className="Products_Hero_Slide"
                style={{ backgroundImage: `url(${s.image})` }}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Green gradient + globe overlay (sits on top of slider) */}
        <div className="Products_Hero_Overlay" />

        {/* Text content on top of everything */}
        <div className="Products_Hero_Content">
          <h1>PRODUCTS</h1>
          <p>
            Comprehensive insurance solutions <br /> tailored to protect what
            matters most.
          </p>
        </div>
      </div>

      <div className="Products_Page_Highlight">
        <p>
          We attach great importance to offering excellent total customer
          service to our <br /> valued clients and meeting all claims
          obligations promptly.
        </p>
        <QuotePolicies />
      </div>
      <div className="Products_Page_Selected">
        <ProductHighlight />
      </div>
      <div className="Products_Page_Others">
        <div>
          <h1>Other Insurance Coverages</h1>
        </div>
        <div className="Products_Page_Policies">
          <div>
            <ProductsItem
              text="Bonds Insurance"
              productLink={"http://localhost:3000/forms"}
            />
          </div>
          <div>
            <ProductsItem
              text="Marine Insurance"
              productLink={"http://localhost:3000/forms"}
            />
          </div>
          <div>
            <ProductsItem
              text="Home Insurance"
              productLink={"http://localhost:3000/forms"}
            />
          </div>
          <div>
            <ProductsItem
              text="Contractors All Risk"
              productLink={"http://localhost:3000/forms"}
            />
          </div>
          <div>
            <ProductsItem
              text="Machinery Breakdown"
              productLink={"http://localhost:3000/forms"}
            />
          </div>
          <div>
            <ProductsItem
              text="Money Insurance"
              productLink={"http://localhost:3000/forms"}
            />
          </div>
          <div>
            <ProductsItem
              text="Erection All Risk"
              productLink={"http://localhost:3000/forms"}
            />
          </div>
          <div>
            <ProductsItem
              text="Goods In-Transit"
              productLink={"http://localhost:3000/forms"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products;
